/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Dd_Charter_DescInputs */

const es_nav_dd_charter_desc = /** @type {(inputs: Nav_Dd_Charter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu barco comercial, mejor gestionado.`)
};

const gl_nav_dd_charter_desc = /** @type {(inputs: Nav_Dd_Charter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu barco comercial, mellor xestionado.`)
};

const en_nav_dd_charter_desc = /** @type {(inputs: Nav_Dd_Charter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your commercial boat, better managed.`)
};

/**
* | output |
* | --- |
* | "Your commercial boat, better managed." |
*
* @param {Nav_Dd_Charter_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_dd_charter_desc = /** @type {((inputs?: Nav_Dd_Charter_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dd_Charter_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_dd_charter_desc(inputs)
	if (locale === "en") return en_nav_dd_charter_desc(inputs)
	return es_nav_dd_charter_desc(inputs)
});